export default __webpack_public_path__ + "static/media/Kaspersky_Evgeny_Valentinovich.961311bd.webp";